require("!!C:\\Disco D\\Projetos\\central-cliente\\node_modules\\script-loader\\addScript.js")(require("!!C:\\Disco D\\Projetos\\central-cliente\\node_modules\\raw-loader\\index.js!C:\\Disco D\\Projetos\\central-cliente\\node_modules\\select2\\dist\\js\\select2.full.min.js"))


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/~/script-loader!C:/Disco D/Projetos/central-cliente/~/select2/dist/js/select2.full.min.js
// module id = ../../../../script-loader/index.js!../../../../select2/dist/js/select2.full.min.js
// module chunks = 3